<div
  class="select-container"
  [ngClass]="flagClass()"
  [ngStyle]="flagBackgroundImageStyle()">
  <select
    #mobileLanguageSelect
    class="select-element"
    [ngModel]="localeSelected"
    (ngModelChange)="emitChangeLocaleEvent($event)">
    <option *ngFor="let locale of locales" [ngValue]="locale">
      {{ locale.name }}
    </option>
  </select>
</div>
